export default __webpack_public_path__ + "static/media/ico-air.8550e9f0.svg";